import { FormControl, MenuItem, Select } from "@material-ui/core";
import { hasValue } from "../../logic/paths";
import { SelectItem } from "../../options";
import { rv } from "../../tokens";
import { ChevronDownIcon } from "../icons";
import FieldShell from "./FieldShell";

interface Props {
  label?: string;
  value: string | number | undefined;
  onChange: (value: string | number) => void;
  items: SelectItem[];
  error?: string;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
}

export default function SelectField({
  label,
  value,
  onChange,
  items,
  error,
  required,
  disabled,
  placeholder = "Select an option",
}: Props) {
  const selectValue = value ?? "";
  const hasCurrentOption = items.some((item) => item.value === selectValue);

  // Preserve a prefilled value that isn't in the option list (no auto-mapping):
  // inject it so the field always renders what the client actually has on file.
  const finalItems: SelectItem[] =
    hasValue(selectValue) && !hasCurrentOption
      ? [{ label: String(selectValue), value: selectValue }, ...items]
      : items;

  return (
    <FieldShell label={label} required={required} error={error}>
      <FormControl variant="outlined" size="small" fullWidth error={Boolean(error)}>
        <Select
          value={selectValue as string | number}
          disabled={disabled}
          displayEmpty
          IconComponent={ChevronDownIcon}
          // Inline style on the value display wins over MUI's `font: inherit`
          // (which otherwise overrides our stylesheet font-family).
          SelectDisplayProps={{ style: { fontFamily: rv.fontSans } }}
          MenuProps={{ PaperProps: { style: { fontFamily: rv.fontSans } } }}
          onChange={(event) => onChange(event.target.value as string | number)}
        >
          <MenuItem value="" disabled>
            {placeholder}
          </MenuItem>
          {finalItems.map((item) => (
            <MenuItem key={String(item.value)} value={item.value as string | number}>
              {item.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </FieldShell>
  );
}
